import { render, staticRenderFns } from "./VerificationError.vue?vue&type=template&id=5fa5f1cc&"
import script from "./VerificationError.vue?vue&type=script&lang=js&"
export * from "./VerificationError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports